import { AppaIcon } from "app/assets/appaIcon";

export function ProtectedSection() {
  return (
    <section className="bg-white-bg dark:bg-gray-400 p-10">
      <div
        className="mt-4 flex flex-col justify-center items-center gap-4 w-full w-max-ppn"
        itemScope
        itemType="https://schema.org/Organization"
      >
        <div className="py-2">
          <h4 className="font-bold text-2xl text-foreground dark:text-gray-800 capitalize text-center">
            You are fully protected
          </h4>
          <p className="md:text-lg text-sm text-gray dark:text-gray-800 text-center">
            We are bound by the code of conduct of the Australian Promotional Products
            Association
          </p>
        </div>
        <div className="px-4">
          <AppaIcon />
        </div>
      </div>
    </section>
  );
}
